// extracted by mini-css-extract-plugin
export default {"loader":"loader_XC3Qd16G"};